import React, {Component} from 'react'
import { formatDate, addAdditionalDays } from '../../actions/dateUtility';

import parse from 'html-react-parser';
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'

const mapStateToProps = ({
                           courses: { selectedCourseCode},
                           course: {selectedCourse},
                           sliders
                         }) => {
  const courseSliders = sliders[selectedCourseCode]

  const {sliderItems = []} = courseSliders.data.find(slider => {
    return slider.id === courseSliders.defaultSlider
  })

  const {title, subtitle, startDate, content} = sliderItems.find(sliderItem => {
    return sliderItem.id === courseSliders.selectedSlide
  })

  return {
    title,
    subtitle,
    startDate,
    content
  }
}

class WeekOverview extends Component {
  formatContent = (text = '') => {
    return '<p>' + text.replace(/\n([ \t]*\n)+/g, '</p><p>')
      .replace('\n', '</p><p>') + '</p>'
  }

  render() {
    const {title, subtitle, startDate, content} = this.props

    if (title || subtitle || startDate || content) {
      return (
        <div className='weekly-content'>
          {title && <h1>{title}</h1>}
          {subtitle && <h2>{subtitle}</h2>}
          {startDate && (
            <h3>{formatDate(startDate, 'd MMM')} &#8211; {formatDate(addAdditionalDays(startDate, 6), 'd MMM')}</h3>
          )}
          {content && parse(this.formatContent(content))}
        </div>
      )
    }

    return null
  }
}

export default withRouter(connect(mapStateToProps)(WeekOverview))
